/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Copy_FromInputs */

const en_task_catalog_copy_from = /** @type {(inputs: Task_Catalog_Copy_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy from another case type`)
};

const pt_br2_task_catalog_copy_from = /** @type {(inputs: Task_Catalog_Copy_FromInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar de outro tipo de caso`)
};

/**
* | output |
* | --- |
* | "Copy from another case type" |
*
* @param {Task_Catalog_Copy_FromInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_copy_from = /** @type {((inputs?: Task_Catalog_Copy_FromInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Copy_FromInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_copy_from(inputs)
	return pt_br2_task_catalog_copy_from(inputs)
});